import { CLICK_ACTIONS } from "../../utils/Constant";
import { ColumnHeaderType } from "../../utils/Types";
import { 
  blankValueGetter,
  departmentValueGetter,
  getDepartmentClassNameGetter,
  getStatusClassNameGetter,
  getTATClassNameGetter,
  grievanceModeValueGetter,
  grievanceSourceValueGetter,
  grievanceTypeValueGetter,
  lobValueGetter,
  statusValueGetter, 
  typeOfRequestValueGetter,
  amountValueGetter, 
  dateValueGetter, 
  farmStatusClassGetter, 
  farmStatusValueGetter, 
  kycStatusClassGetter, 
  kycStatusValueGetter, 
  paymentStatusValueGetter, 
  policyStardateValueGetter, 
  policyStatusClassGetter, 
  policyStatusValueGetter, 
  policyValueGetter, 
  proposalStatusClassGetter, 
  proposalStatusValueGetter
} from "../../utils/Util";

export const DASHBOARD_HEADERS: ColumnHeaderType[] = [
  {
    name: '',
    field: '',
    sortable: false,
    valueGetter: blankValueGetter,
    action: CLICK_ACTIONS.SELECT_GRIEVANCE,
    clickable: true,
    searchable: false,
    checkbox: true,
  },  
  {
    name: 'Grievance ID',
    field: 'grievanceId',
    sortable: false,
    valueGetter: blankValueGetter,
    action: CLICK_ACTIONS.VIEW_GRIEVANCE,
    clickable: true,
    searchable: true
  },  
  {
    name: 'Type of Request',
    field: 'typeOfRequest',
    sortable: false,
    valueGetter: typeOfRequestValueGetter,
    clickable: false,
    searchable: false
  },
  {
    name: 'Line of Business',
    field: 'lobId',
    sortable: false,
    valueGetter: lobValueGetter,
    clickable: false,
    searchable: false
  },
  {
    name: 'Claim ID',
    field: 'claimId',
    sortable: false,
    valueGetter: blankValueGetter,
    clickable: false,
    searchable: true,
  },
  {
    name: 'Grievance Intimation Date & Time',
    field: 'createdDate',
    sortable: false,
    valueGetter: blankValueGetter,
    clickable: false,
  },
  {
    name: 'Turn Around Time',
    field: 'tat',
    sortable: false,
    valueGetter: blankValueGetter,
    clickable: false,
    searchable: false,
    classNameGetter: getTATClassNameGetter
  },
  {
    name: 'Aging',
    field: 'daysSpent',
    sortable: false,
    valueGetter: blankValueGetter,
    clickable: false,
    searchable: false,
  },
  {
    name: 'Department',
    field: 'department',
    sortable: false,
    valueGetter: departmentValueGetter,
    clickable: false,
    searchable: false,
    classNameGetter: getDepartmentClassNameGetter
  },
  {
    name: 'SPOC',
    field: 'spoc',
    sortable: false,
    searchable: true,
    valueGetter: blankValueGetter,
    clickable: false,
  },
  {
    name: 'Status',
    field: 'status',
    sortable: false,
    searchable: false,
    valueGetter: statusValueGetter,
    clickable: false,
    classNameGetter: getStatusClassNameGetter
  },
  {
    name: 'Name',
    field: 'name',
    sortable: false,
    searchable: true,
    valueGetter: blankValueGetter,
    clickable: false,
  },
  {
    name: 'Mobile Number',
    field: 'mobileNumber',
    sortable: false,
    searchable: false,
    valueGetter: blankValueGetter,
    clickable: false,
  },
  {
    name: 'Policy Number',
    field: 'policyNumber',
    sortable: false,
    searchable: false,
    valueGetter: blankValueGetter,
    clickable: false,
  },
  {
    name: 'Reference No.',
    field: 'referenceId',
    sortable: false,
    searchable: true,
    valueGetter: blankValueGetter,
    clickable: false,
  },
  {
    name: 'Type of Grievance',
    field: 'grievanceType',
    sortable: false,
    searchable: false,
    valueGetter: grievanceTypeValueGetter,
    clickable: false,
  },
  {
    name: 'Source of Complaint',
    field: 'grievanceSource',
    sortable: false,
    searchable: false,
    valueGetter: grievanceSourceValueGetter,
    clickable: false,
  },
  {
    name: 'Mode of Complaint',
    field: 'grievanceMode',
    sortable: false,
    searchable: false,
    valueGetter: grievanceModeValueGetter,
    clickable: false,
  },
  {
    name: 'Documents',
    field: '',
    sortable: false,
    valueGetter: blankValueGetter,
    action: CLICK_ACTIONS.VIEW_DOCUMENT,
    clickable: true,
  },
  {
    name: 'Date of Closure',
    field: 'closureDate',
    sortable: false,
    valueGetter: blankValueGetter,
    clickable: false,
  },
];

export const CUSTOMER_DETAILS_HEADERS: ColumnHeaderType[] = [
    {
      name: 'Customer Name',
      field: 'customerName',
      sortable: false,
      valueGetter: blankValueGetter,
      action: CLICK_ACTIONS.SELECT_CUSTOMER,
      clickable: true,
    },
    {
      name: 'Mobile Number',
      field: 'mobileNumber',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'Pin Code',
      field: 'pincode',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'City',
      field: 'city',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'State',
      field: 'state',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
];

export const CLAIM_DETAILS_HEADERS: ColumnHeaderType[] = [
    {
      name: 'Policy Number',
      field: 'policyNumber',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'Claim Number',
      field: 'claimNumber',
      sortable: false,
      valueGetter: blankValueGetter,
      action: CLICK_ACTIONS.SELECT_CLAIM,
      clickable: true,
    },
    {
      name: 'Claim Status',
      field: 'claimStatus',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'Claim Sub Status',
      field: 'claimSubStatus',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'Reason For Claim Status',
      field: 'claimRemarks',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'Claim Intimation Date',
      field: 'claimIntimationDate',
      sortable: false,
      valueGetter: dateValueGetter,
      clickable: false,
    },
    {
      name: 'Claim Settlement Date',
      field: 'claimSettlementDate',
      sortable: false,
      valueGetter: dateValueGetter,
      clickable: false,
    },
    {
      name: 'Settlement Amount',
      field: 'claimSettlementAmount',
      sortable: false,
      valueGetter: amountValueGetter,
      clickable: false,
    },
    {
      name: 'Crop',
      field: 'crop',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'Product',
      field: 'product',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'Season',
      field: 'season',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'Year',
      field: 'quotationDate',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
];

export const PMFBY_CLAIM_DETAILS_HEADERS: ColumnHeaderType[] = [
  {
    name: 'Application Number',
    field: 'policyNumber',
    sortable: false,
    valueGetter: blankValueGetter,
    clickable: false,
  },
  {
    name: 'Claim Number',
    field: 'claimNumber',
    sortable: false,
    valueGetter: blankValueGetter,
    action: CLICK_ACTIONS.SELECT_CLAIM,
    clickable: true,
  },
  {
    name: 'Claim Status',
    field: 'claimStatus',
    sortable: false,
    valueGetter: blankValueGetter,
    clickable: false,
  },
  {
    name: 'Claim Sub Status',
    field: 'claimSubStatus',
    sortable: false,
    valueGetter: blankValueGetter,
    clickable: false,
  },
  {
    name: 'Reason For Claim Status',
    field: 'claimRemarks',
    sortable: false,
    valueGetter: blankValueGetter,
    clickable: false,
  },
  {
    name: 'Claim Intimation Date',
    field: 'claimIntimationDate',
    sortable: false,
    valueGetter: dateValueGetter,
    clickable: false,
  },
  {
    name: 'Claim Settlement Date',
    field: 'claimSettlementDate',
    sortable: false,
    valueGetter: dateValueGetter,
    clickable: false,
  },
  {
    name: 'Settlement Amount',
    field: 'claimSettlementAmount',
    sortable: false,
    valueGetter: amountValueGetter,
    clickable: false,
  },
  {
    name: 'Crop',
    field: 'crop',
    sortable: false,
    valueGetter: blankValueGetter,
    clickable: false,
  },
  {
    name: 'Product',
    field: 'product',
    sortable: false,
    valueGetter: blankValueGetter,
    clickable: false,
  },
  {
    name: 'Season',
    field: 'season',
    sortable: false,
    valueGetter: blankValueGetter,
    clickable: false,
  },
  {
    name: 'Year',
    field: 'quotationDate',
    sortable: false,
    valueGetter: blankValueGetter,
    clickable: false,
  },
];

export const POLICY_DETAILS_HEADERS: ColumnHeaderType[] = [
    {
      name: 'Policy Number',
      field: 'policyNumber',
      sortable: false,
      valueGetter: blankValueGetter,
      action: CLICK_ACTIONS.SELECT_POLICY,
      clickable: true,
    },
    {
      name: 'Policy Holder Name',
      field: 'policyHolderName',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'Policy Start Date',
      field: 'policyStartDate',
      sortable: false,
      valueGetter: policyStardateValueGetter,
      clickable: false,
    },
    {
      name: 'Policy End Date',
      field: 'policyEndDate',
      sortable: false,
      valueGetter: dateValueGetter,
      clickable: false,
    },
    {
      name: 'Crop',
      field: 'crop',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'Premium',
      field: 'premium',
      sortable: false,
      valueGetter: amountValueGetter,
      clickable: false,
    },
    {
      name: 'Product',
      field: 'product',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'Season',
      field: 'season',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'Year',
      field: 'quotationDate',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
];

export const PROPOSAL_DETAILS_HEADERS: ColumnHeaderType[] = [
    {
      name: 'FIN Number',
      field: 'fid',
      sortable: false,
      valueGetter: blankValueGetter,
      action: CLICK_ACTIONS.SELECT_PROPOSAL,
      clickable: true,
    },
    {
      name: 'Proposer Name',
      field: 'proposalName',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'Proposal Issue Date',
      field: 'proposalIssueDate',
      sortable: false,
      valueGetter: dateValueGetter,
      clickable: false,
    },
    {
      name: 'Payment Status',
      field: 'paymentStatus',
      sortable: false,
      valueGetter: paymentStatusValueGetter,
      clickable: false,
    },
    {
      name: 'Crop',
      field: 'crop',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'Product',
      field: 'product',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'Season',
      field: 'season',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
    {
      name: 'Year',
      field: 'quotationDate',
      sortable: false,
      valueGetter: blankValueGetter,
      clickable: false,
    },
];

export const APPLICATION_LIST_HEADERS: ColumnHeaderType[] = [
  {
    name: 'Application Number',
    field: 'applicationId',
    sortable: false,
    valueGetter: blankValueGetter,
    action: CLICK_ACTIONS.SELECT_APPLICATION,
    clickable: true,
  },
  {
    name: 'Application Status',
    field: 'applicationStatus',
    sortable: false,
    valueGetter: blankValueGetter,
    clickable: false,
  },
  {
    name: 'Policy ID',
    field: 'policyNo',
    sortable: false,
    valueGetter: policyValueGetter,
    clickable: false,
  },
];

export const RWBCIS_APPLICATION_LIST_HEADERS: ColumnHeaderType[] = [
  {
    name: 'Application Number',
    field: 'applicationId',
    sortable: false,
    valueGetter: blankValueGetter,
    action: CLICK_ACTIONS.SELECT_APPLICATION,
    clickable: true,
  },
  {
    name: 'Application Status',
    field: 'applicationStatus',
    sortable: false,
    valueGetter: blankValueGetter,
    clickable: false,
  },
  {
    name: 'Policy ID',
    field: 'policyNo',
    sortable: false,
    valueGetter: blankValueGetter,
    clickable: false,
  },
];

export const RETAIL_APPLICATION_HEADERS: ColumnHeaderType[] = [
  {
    name: 'FIN Number',
    field: 'fid',
    sortable: false,
    valueGetter: blankValueGetter,
    action: CLICK_ACTIONS.SELECT_RETAIL_APPLICATION,
    clickable: true,
  },
  {
    name: 'Policy Id',
    field: 'applicationId',
    sortable: false,
    valueGetter: blankValueGetter,
    clickable: false,
  },
  {
    name: 'KYC Status',
    field: 'ckycStatus',
    sortable: false,
    valueGetter: kycStatusValueGetter,
    clickable: false,
    classNameGetter: kycStatusClassGetter
  },
  {
    name: 'Farm Details Status',
    field: 'farmStatus',
    sortable: false,
    valueGetter: farmStatusValueGetter,
    clickable: false,
    classNameGetter: farmStatusClassGetter
  },
  {
    name: 'Proposal Status',
    field: 'proposalStatus',
    sortable: false,
    valueGetter: proposalStatusValueGetter,
    clickable: false,
    classNameGetter: proposalStatusClassGetter,
  },
  {
    name: 'Policy Status',
    field: 'policyStatus',
    sortable: false,
    valueGetter: policyStatusValueGetter,
    clickable: false,
    classNameGetter: policyStatusClassGetter
  },
];

export const BULK_ASSIGN_HEADERS: ColumnHeaderType[] = [
  {
    name: '',
    field: '',
    sortable: false,
    valueGetter: blankValueGetter,
    action: CLICK_ACTIONS.SELECT_GRIEVANCE,
    clickable: true,
    searchable: false,
    checkbox: false,
  }, 
  {
    name: 'Grievance ID',
    field: 'grievanceId',
    sortable: false,
    valueGetter: blankValueGetter,
    action: CLICK_ACTIONS.VIEW_GRIEVANCE,
    clickable: true,
    searchable: false
  },  
  {
    name: 'Claim ID',
    field: 'claimId',
    sortable: false,
    valueGetter: blankValueGetter,
    clickable: false,
    searchable: false
  },
  {
    name: 'Grievance Intimation Date & Time',
    field: 'createdDate',
    sortable: false,
    valueGetter: blankValueGetter,
    clickable: false,
    searchable: false
  },
  {
    name: 'Department',
    field: 'department',
    sortable: false,
    valueGetter: departmentValueGetter,
    clickable: false,
    searchable: false,
    classNameGetter: getDepartmentClassNameGetter
  },
  {
    name: 'SPOC',
    field: 'spoc',
    sortable: false,
    valueGetter: blankValueGetter,
    clickable: false,
    searchable: false
  },
  {
    name: 'Status',
    field: 'status',
    sortable: false,
    valueGetter: statusValueGetter,
    clickable: false,
    searchable: false,
    classNameGetter: getStatusClassNameGetter
  },
];